import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './NavigationBar.scss';

export default class NavigationBar extends Component {
    static propTypes = {
        className: PropTypes.string
    };

    render() {
        const {children, className} = this.props;
        const navStyles = classnames(styles.navigationBar, className ? className : '');
        return (
            <nav className={navStyles}>
                {children}
            </nav>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Header/NavigationBar.js